export const CB = 'CB';
export const GOOGLE_PAY = 'GOOGLE_PAY';
export const APPLE_PAY = 'APPLE_PAY';
export const COFIDIS = 'COFIDIS';
export const CRYPTO_LYZI = 'CRYPTO_LYZI';



// WEBPACK FOOTER //
// ./src/constants/paymentMethods.js